export default "__VITE_ASSET__LE00ZZvV__"